import React from 'react'
import  heroImg from "../../../../assets/images/tlsm-model.png"   
// /var/www/Telsim/Telsim_RetailTAP_React/src/assets/images/tlsm-model.png
                       


function RechargeBanner() {
  return (
    <div>
         <section id="hero-2" className="hero-2 d-flex align-items-center">
      <div className="container-fluid">
        {/* <div className="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center justify-content-lg-end">
          <img
            src={TechnologyImg}
            alt="Future of Smartphones eSIM Australia"
            className="img-fluid hero-img-2"
          />
        </div> */}
        <div className='hero-border'>  
        <div className="row"> {/* Corrected class to className */}
          <div className="col-12 col-lg-6">
            <div className="hero-background">
              <div className='hero-content'>
              <p className='hero-text'>Sell with a single click ,effortlessly.</p>
              <p className='hero-text'>unlock endless possiblilities with Telsim</p>
              </div>

            </div>
          </div>
  
          <div className="col-12 col-lg-6" style={{marginLeft:"-20px "}}>
            <img
              // src={heroImg}
              alt=""
              className="img-fluid banner-img"
            />
          </div>
        </div>
        </div>

      </div>
    </section>













    </div>
  )
}

export default RechargeBanner